module.exports = __webpack_public_path__ + "img/power_bi.5be1537a.svg";